import { useEffect, useState } from "react";

export const GENESIS_END_ISO = "2026-12-12T00:00:00Z";

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ testid = "genesis-countdown" }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, new Date(GENESIS_END_ISO).getTime() - now);
  const cells = [
    [Math.floor(diff / 86400000), "DAYS"],
    [pad(Math.floor((diff % 86400000) / 3600000)), "HRS"],
    [pad(Math.floor((diff % 3600000) / 60000)), "MIN"],
    [pad(Math.floor((diff % 60000) / 1000)), "SEC"],
  ];

  return (
    <div className="flex items-center gap-2 sm:gap-2.5" data-testid={testid}>
      {cells.map(([v, l]) => (
        <div
          key={l}
          className="flex min-w-[56px] sm:min-w-[64px] flex-col items-center rounded-xl border border-cyan-400/20 bg-black/60 backdrop-blur-md px-3 py-2.5 shadow-[0_0_24px_rgba(0,240,255,0.06)]"
        >
          <span className="font-mono text-xl sm:text-2xl font-medium text-cyan-400 tabular-nums leading-none">
            {v}
          </span>
          <span className="mt-1.5 font-mono text-[8px] tracking-[0.3em] text-zinc-500">{l}</span>
        </div>
      ))}
    </div>
  );
};
